export const randomString = () => {
    return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
}

export const generateGuid = () => {
    return Math.random().toString(36).substr(2) + Date.now()
}